module.exports = __webpack_public_path__ + "static/media/ODS08.97557023.jpg";